import CardBoard from './CardBoard';
import CardGrid from './CardGrid';

export { CardGrid };
export default CardBoard;
